<template>
  <div class="gpt-viewer-text">
    <v-md-preview class="content" :text="text"></v-md-preview>
  </div>
</template>

<script>
export default {
    name: 'gpt-viewer-text',
    data () {
        let text = '';
        return { text };
    },
    props: {
        url: {
            type: String,
            default: null
        }
    },
    watch: {
        url () {
            this.load();
        }
    },
    mounted () {
        this.load();
    },
    methods: {
        async load () {
            if (!this.url) return;
            let resp = await fetch(this.url);
            let text = await resp.text();
            this.text = text;
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-viewer-text {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 2em;
    background: var(--page-bg-img);
    background-size: cover;
    .content {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #FFF;
        border-radius: 0.5em;
        padding: 1em;
        overflow: auto;
    }
}
</style>
